import { Images } from '@/app/assets/images';

import * as R from 'ramda';

export const getImageUrl = (
	image: any,
	defaultImage: string = Images.home.courseBanner
) => {
	const imageUrl = R.pathOr(defaultImage, ['url'], image);
	const imagePlaceholder = R.pathOr(defaultImage, ['placeholder'], image);
	return { imageUrl, imagePlaceholder };
};
